var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDownPrimary(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2323 0.5103C11.8768 0.163233 11.3026 0.163233 10.9472 0.5103L6.49943 4.85308L2.0517 0.510299C1.69624 0.163232 1.12204 0.163232 0.766591 0.510299C0.411137 0.857365 0.411137 1.41801 0.766591 1.76508L5.86143 6.7397C6.21689 7.08677 6.79108 7.08677 7.14653 6.7397L12.2414 1.76508C12.5877 1.42691 12.5877 0.857366 12.2323 0.5103Z",
    fill: "#883E89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownPrimary);
export default __webpack_public_path__ + "static/media/chevron-down-primary.a7cd8ab19f7ff94def9f04d4091f7ce4.svg";
export { ForwardRef as ReactComponent };